import { ImageTransformationTemplateEntity } from '../types';

export default function computeSrcset(imageSrc: string, tts: ImageTransformationTemplateEntity): string[] {
  const sources: string[] = [];
  const hasQuery = imageSrc.includes('?') ? '&' : '?';

  Object.entries(tts).forEach(([key, value]) => {
    const density = key === '1' ? '' : ` ${key}x`;
    sources.push(imageSrc + (value ? hasQuery + applyTemplate(value) : '') + density);
  });
  return sources;
}

function applyTemplate(transTemp: [] | string): string {
  return Array.isArray(transTemp) ? transTemp.map((tt) => `$${tt}$`).join('&') : `$${transTemp}$`;
}
